module.exports = __webpack_public_path__ + "static/media/nowLivePublic.314d5f96.svg";